<template>
    <div class="login">
        <div class="login-container">
            <div class="left-container"></div>
            <div class="right-container">
                <div class="top-logo"></div>
                <div class="submit-container">
                    <div class="line-group">
                        <div class="input-group">
                            <div class="input-label">
                                <i class="iconfont iconlogin_user"></i>
                            </div>
                            <div class="input-content">
                                <input type="text" @keydown.enter="login" placeholder="账号" v-model="loginName" />
                            </div>
                        </div>
                    </div>
                    <div class="line-group">
                        <div class="input-group">
                            <div class="input-label">
                                <i class="iconfont iconlogin_lock"></i>
                            </div>
                            <div class="input-content">
                                <input type="password" @keydown.enter="login" placeholder="密码" v-model="password" />
                            </div>
                        </div>
                    </div>
                    <div class="line-group">
                        <div class="input-group">
                            <div class="input-label">
                                <i class="iconfont iconlogin_key"></i>
                            </div>
                            <div class="input-content">
                                <input type="text" @keydown.enter="login" placeholder="验证码" v-model="verifycode" />
                            </div>
                        </div>
                        <div class="code-container">
                            <el-image
                                :src="verifycodeSrc"
                                class="verifyimg"
                                @click="onClick"
                                @error="onError"
                            >
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>单击重新加载
                                </div>
                            </el-image>
                        </div>
                    </div>
                    <div class="login-btn" @click="login">登 录</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loginName: '',
            password: '',
            verifycode: '',
            verifycodeSrc: '',
            safeNum: 5 // 防止死循环
        };
    },
    methods: {
        getVerifycodeSrc() {
            this.verifycodeSrc = `${this.$http.baseUrl}/common/verifycode/v1?d=${new Date() * 1}`;
        },
        onClick() {
            this.safeNum = 5;
            this.getVerifycodeSrc();
        },
        onError() {
            this.safeNum --;
            if (this.safeNum > 0) {
                this.getVerifycodeSrc();
            }
        },
        login() {
            this.$http
                .post(
                    '/login',
                    {
                        loginName: this.loginName,
                        password: this.password,
                        verifycode: this.verifycode,
                        deviceInfo: 'WEB',
                        system: 'office'
                    },
                    '登录中……'
                )
                .then(res => {
                    this.$store.dispatch('updateUserInfo').then(res => {
                        this.$router.push('/home');
                        this.$store.dispatch('updateCenter');
                    })
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.login {
    width: 100vw;
    height: 100vh;
    position: relative;
    background-image: url('./images/loginBG.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;

    .login-container {
        width: 1100px;
        height: 700px;
        overflow: hidden;
        border-radius: 4px;
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        @media screen and (max-width: 1100px) {
            width: 500px;
        }

        .left-container {
            width: 600px;
            height: 100%;
            background-image: url('./images/timg.png');
            @media screen and (max-width: 1100px) {
                width: 0;
            }
        }

        .right-container {
            width: 500px;
            height: 100%;
            background-color: #ffffff;

            .top-logo {
                width: 100%;
                height: 230px;
                background-image: url('./images/logo.png');
                background-repeat: no-repeat;
                background-position: center;
            }

            .submit-container {
                height: 470px;
                padding: 0 30px;
                box-sizing: border-box;

                .line-group {
                    height: 60px;
                    margin-bottom: 30px;
                    display: flex;
                    justify-content: space-between;

                    .input-group {
                        width: 440px;
                        height: 100%;
                        background: rgba(247, 255, 250, 1);
                        border: 1px solid rgba(239, 240, 244, 1);
                        padding: 5px 0;
                        border-radius: 4px;
                        box-sizing: border-box;
                        display: flex;

                        &:nth-last-child(2) {
                            width: 280px;
                        }

                        .input-label {
                            width: 60px;
                            height: 50px;
                            line-height: 50px;
                            text-align: center;
                            border-right: 1px solid rgba(239, 240, 244, 1);

                            .iconfont {
                                font-size: 22px;
                                color: #68e880;
                            }
                        }

                        .input-content {
                            width: calc(100% - 60px);
                            height: 50px;
                            line-height: 50px;
                            padding-left: 10px;

                            input {
                                width: 98%;
                                height: 100%;
                                outline: none;
                                border: none;
                                background-color: rgba(0, 0, 0, 0);
                                border: 0;
                                padding: 0;
                            }

                            &:nth-last-child {
                                background-color: #fff;
                            }
                        }
                    }

                    .code-container {
                        width: 140px;
                        height: 100%;

                        .el-image {
                            width: 100%;
                            height: 100%;
                            border-radius: 4px;
                            cursor: pointer;
                            .image-slot {
                                height: 100%;
                                width: 100%;
                                background: #eee;
                                display: flex;
                                align-items: center;
                                color: #ccc;
                                justify-content: center;
                                i {
                                    font-size: 18px;
                                    margin-right: 5px;
                                    margin-top: -1px;
                                }
                            }
                        }
                    }

                    &:nth-last-child(2) {
                        margin: 0;
                    }
                }

                .login-btn {
                    width: 440px;
                    height: 60px;
                    line-height: 60px;
                    font-size: 26px;
                    color: #ffffff;
                    margin-top: 50px;
                    user-select: none;
                    text-align: center;
                    border-radius: 4px;
                    cursor: pointer;
                    margin-bottom: 30px;
                    background: linear-gradient(
                        87deg,
                        rgba(0, 220, 130, 0.8),
                        rgba(104, 232, 128, 0.8)
                    );

                    &:active {
                        background: linear-gradient(
                            -87deg,
                            rgba(0, 220, 130, 0.8),
                            rgba(104, 232, 128, 0.8)
                        );
                    }
                }

                .download {
                    text-decoration: underline;
                    cursor: pointer;
                    font-size: 16px;
                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
.codeImg {
    height: 300px;
    background: linear-gradient(
        0deg,
        rgba(0, 220, 130, 0.8),
        rgba(104, 232, 128, 0.8)
    );
    img {
        height: 100%;
        width: 100%;
    }
}
</style>